import React from 'react';
import {WeaLocaleProvider} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;
import Header from './Common/header'

export default class Content_task extends React.Component {
    render() {
        const {data = {}, eid} = this.props;
        const { moreLocal, iconMore, iconEsymbol } = data;
        const tr = (
            <tr height="18">
                <td width="8"><img src="/images/homepage/style/style1/esymbol_wev8.gif" alt=""/></td>
                <td width="*"><a href="javascript:;"><font className="font">{getLabel(387821,"Gmail Labs推出搜索自动完成功能")}</font></a></td>
            </tr>
        );
        const tr2 = (
            <tr className="sparator" height="1px">
                <td colSpan="3"/>
            </tr>
        );

        return (
            <div className="item" id={`item_${eid}`}>
                <Header data={data} eid={eid}/>
                <div className="content" id={`content_${eid}`}>
                    <div className="content_view" id={`content_view_id_${eid}`}>
                        <div className="tab2">
                            <table height="32" cellSpacing="0" cellPadding="0">
                                <tr height="32">
                                    <td title={getLabel(84046,'新任务')+ '(5)' } style={{width: '77px', overflowWrap: 'break-word', paddingTop: '5px', verticalAlign: 'top', height: '32px'}}>{getLabel(84046,'新任务')}
                                        (<font style={{color: 'red'}}>5</font>)
                                    </td>
                                    <td title={getLabel(84048,'新反馈')+ '(0)' } style={{width: '77px', overflowWrap: 'break-word', paddingTop: '5px', verticalAlign: 'top', height: '32px'}}>{getLabel(84048,'新反馈')}
                                        (<font style={{color: 'red'}}>0</font>)
                                    </td>
                                    <td title={getLabel(15537,'今天') + '(0)'} style={{width: '77px', overflowWrap: 'break-word', paddingTop: '5px', verticalAlign: 'top', height: '32px'}}>{getLabel(15537,'今天')}
                                        (<font style={{color: 'red'}}>0</font>)
                                    </td>
                                    <td title={getLabel(22488,'明天') + '(0)'} style={{width: '77px', overflowWrap: 'break-word', paddingTop: '5px', verticalAlign: 'top', height: '32px'}}>{getLabel(22488,'明天')}
                                        (<font style={{color: 'red'}}>0</font>)
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <table width="100%">
                            {tr}{tr2}{tr}{tr2}{tr}{tr2}{tr}{tr2}{tr}
                        </table>
                    </div>
                    <div className="footer" id={`footer_${eid}`} style={{textAlign: 'right'}}>
                        {moreLocal == 'footer' ? <a href="javascript:;"><img src={iconMore} alt=""/></a> : ''}
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4public/wea-element-preview/content/Content_task.js